export const TAGLINE = "Kingdom Sound. Urban Energy.";

export const SOCIALS = {
    instagram: "https://www.instagram.com/ayevibemuzik",
    tiktok: "https://www.tiktok.com/@therealayevibemuzik",
    youtube: "https://www.youtube.com/@ayevibemuzik",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1586610609621-5741b2544b38?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85",
};

export const STATS = [
    { value: 8, suffix: "", label: "Albums" },
    { value: 6, suffix: "", label: "Singles" },
    { value: 100, suffix: "+", label: "Songs" },
];
